import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import * as R from 'ramda';
import PageLoader from '../../../../../../components/PageLoader';
import { accounts } from '../../../../../../redux/accounts/action';
import { selectAccountTypesListItems } from '../../../../../../redux/account-types/selector';
import { toast } from 'react-toastify';
import { selectAccountsListItems } from '../../../../../../redux/accounts/selector';
import { selectCustomersQueryItems } from '../../../../../../redux/customers/selector';
import { customers } from '../../../../../../redux/customers/action';
import CustomerComponent from '../components/customer.component';
import { accountTypes } from '../../../../../../redux/account-types/action';
import storePersist from '../../../../../../redux/storePersist';

const ManagementCustomer = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const accountTypeItems = useSelector(selectAccountTypesListItems)
    const accountItems = useSelector(selectAccountsListItems)
    const CustomersQuery = useSelector(selectCustomersQueryItems)


    const [
        selectedCustomers,
        setSelectedCustomers
    ] = useState<any>({})

    const [
        selectedAccounts,
        setSelectedAccounts
    ] = useState<any>({
        LoginInfo: {},
        UserInfo: {},
        AccountInfo: {
            IsPersonAccount: true,
            IsCustomerPortalEnabled: true,
            IsVendorPortalEnabled: false,
            IsPartnerEnabled: false,
            IsAccountVerified: true,
            IsGuestAccessEnabled: true,
            IsLimitedToOrganizationUnit: false,
            EnableOnNetworkLogisticsSupport: true,
            MappedAccountTypes: {}
        },
        AccountAddress: {},
        PrimaryAddress: {}

    })
    const fetchCustomersQueryById = () => {
        dispatch(customers.query({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/sales/crm/logistics-customers/query`, entity: 'customers', jsonData: {

                Records: [
                    {
                        "Context": {},
                        "Message": {
                            "TenantId": storePersist.get('accessTokenMetadata').current?.TokenMetadata?.TenantId,
                            "Id": parmas?.id,

                        }
                    }
                ]

            }
        })).then(() => {
            setIsQuery(true)
        }).then(() => {
            setIsLoading(false)
        })

    }

    const handleInnerFormChange: any = (event: any, field: string, data: any) => {
        const fields = R.split(
            '.',
            field
        );
        const value = { ...data, [fields[1]]: event }// inner data update
        setSelectedAccounts({ ...selectedAccounts, [fields[0]]: value });
        setSelectedCustomers({ ...selectedCustomers, [fields[0]]: value });
    }
    const handleBasicInnerFormChange: any = (event: any, field: string) => {
        setSelectedCustomers({ ...selectedCustomers, [field]: event });
    }

    useEffect(
        () => {
            dispatch(accounts.list({
                url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/rms/accounts/list`, entity: 'accounts', jsonData: {}
            }))
                .then(() => {

                    dispatch(accountTypes.list({
                        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/account-types/list`, entity: 'accountTypes', jsonData:
                            { "PageNumber": 1, "PageSize": 10000, "SortField": "Id", "SortOrder": "desc" }
                    }))
                }).then(() => {
                    if (parmas?.id > 0) {
                        fetchCustomersQueryById()
                        setIsLoading(false)
                    } else {
                        setIsLoading(false)
                    }
                })
        },
        []
    )
    useEffect(
        () => {

            if (isQuery) {
                setSelectedCustomers({
                    Id: CustomersQuery?.result?.items?.Id,
                    UserProfile: CustomersQuery?.result?.items?.UserProfile,
                    IsDeliveryHubEnabled: CustomersQuery?.result?.items?.IsDeliveryHubEnabled,
                    Login: CustomersQuery?.result?.items?.Login,
                    Account: CustomersQuery?.result?.items?.Account,
                    PrimaryAddress: CustomersQuery?.result?.items?.PrimaryAddress,
                    GSTInfo: CustomersQuery?.result?.items?.TaxInfo?.GSTInfo,
                    CustomerInfo: CustomersQuery?.result?.items?.CustomerInfo
                })

            }
        },
        [isQuery]
    )

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        if (parmas?.id > 0) {
            await dispatch(customers.resetAction({ actionType: 'update' }))
            await dispatch(customers.update({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/sales/crm/logistics-customers`, entity: 'customers', jsonData: {

                    Records: [
                        {
                            Context: {},
                            Message: {
                                Id: selectedCustomers?.Id,
                                Login: selectedCustomers?.Login,
                                UserProfile: selectedCustomers?.UserProfile,
                                CustomerInfo: selectedCustomers?.CustomerInfo,
                                Account: selectedCustomers?.Account,
                                PrimaryAddress: selectedCustomers?.PrimaryAddress,
                                TaxInfo: {
                                    GSTInfo: selectedCustomers?.GSTInfo
                                },
                                IsDeliveryHubEnabled: selectedCustomers?.IsDeliveryHubEnabled
                            }
                        }
                    ]
                }
            })).then(() => {
                back()
            })

        } else if (selectedAccounts?.LoginInfo?.Password === selectedAccounts?.LoginInfo?.ConfirmPassword) {
            selectedAccounts.UserInfo.Salutation = 0
            let accountTypes = _.find(accountTypeItems.result.items, ['Name', 'Logistics_Customer']);
            selectedAccounts.AccountInfo.Name = `${selectedAccounts?.UserInfo?.FirstName} ${selectedAccounts?.UserInfo?.LastName}`
            selectedAccounts.AccountInfo.TypeId = 360
            selectedAccounts.AccountInfo.IsPersonAccount = false
            selectedAccounts.AccountInfo.MappedAccountTypes.MappedAccountTypeIds = [accountTypes.Id]
            selectedAccounts.AccountAddress.PrimaryAddress = selectedAccounts?.PrimaryAddress
            selectedAccounts.AccountAddress.PrimaryAddress.FaxNumber = selectedAccounts?.LoginInfo.PhoneNumber
            selectedAccounts.AccountAddress.PrimaryAddress.GeocodeAccuracy = 0,
                selectedAccounts.AccountAddress.PrimaryAddress.Latitude = 0,
                selectedAccounts.AccountAddress.PrimaryAddress.Longitude = 0,
                selectedAccounts.AccountAddress.PrimaryAddress.OpeningHoursTypeId = 30,
                selectedAccounts.AccountAddress.IsUsePrimaryAddressAsBillingAddress = true
            selectedAccounts.AccountAddress.IsUsePrimaryAddressAsShippingAddress = true
            selectedAccounts.AccountAddress.BillingAddress = {}
            selectedAccounts.AccountAddress.ShippingAddress = {}
            const data = _.omit(selectedAccounts, 'PrimaryAddress');
            await dispatch(accounts.resetAction({ actionType: 'create' }))
            await dispatch(accounts.create({
                url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/rms/accounts`, entity: 'accounts', jsonData: {

                    Records: [
                        {
                            Context: {},
                            Message: data

                        }
                    ]

                }
            })).then(() => {
                back()
            })
        } else {
            toast.error("Password and Confirm Password must be same.")
        }

    }

    const back = () => {
        navigate('/management/sales/crm/customers')
    }


    return (
        <>
            {isLoading ? <PageLoader /> :
                <CustomerComponent
                    id={parmas?.id}
                    selectedAccounts={selectedAccounts}
                    handleInnerFormChange={handleInnerFormChange}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    accounts={accountItems?.result?.items}
                    handleBasicInnerFormChange={handleBasicInnerFormChange}
                    selectedCustomers={selectedCustomers}
                />
            }

        </>
    )

}

export default ManagementCustomer;